import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from '@/components/ui/button';
import { Leaf, MapPin, Users, ShoppingBasket } from 'lucide-react';
import { FACEBOOK_GROUP_URL } from './FacebookBanner';

/**
 * Welcome Modal Component
 * Shown to first-time visitors to introduce the app
 */
const WelcomeModal = ({ open, onOpenChange, navigate }) => {
  const handleGetStarted = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent 
        className="sm:max-w-md max-h-[90vh] overflow-y-auto"
        data-testid="welcome-modal"
      >
        <DialogHeader>
          <div className="flex justify-center mb-4">
            <div className="bg-gradient-to-br from-green-400 to-green-600 p-4 rounded-2xl shadow-lg">
              <Leaf className="w-12 h-12 text-white" />
            </div>
          </div>
          <DialogTitle className="text-center text-2xl">
            Welcome to Neighbours Pantry!
          </DialogTitle>
          <DialogDescription className="text-center text-base">
            Discover local honesty boxes and farm stalls on the Sunshine Coast
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          {/* Feature Highlights */}
          <div className="space-y-3">
            <div className="flex items-start gap-3 p-3 bg-green-50 rounded-lg">
              <MapPin className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-gray-800">Find Local Produce</p>
                <p className="text-sm text-gray-600">Browse the map to discover honesty boxes near you</p>
              </div>
            </div>
            
            <div className="flex items-start gap-3 p-3 bg-blue-50 rounded-lg">
              <ShoppingBasket className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-gray-800">Support Local Vendors</p>
                <p className="text-sm text-gray-600">Fresh eggs, veggies, fruits, and homemade goods</p>
              </div>
            </div>
            
            <div className="flex items-start gap-3 p-3 bg-purple-50 rounded-lg">
              <Users className="w-5 h-5 text-purple-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-gray-800">Join Our Community</p>
                <p className="text-sm text-gray-600">Connect with neighbours and share your finds</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="flex flex-col gap-2">
          <Button
            onClick={handleGetStarted}
            className="w-full bg-green-600 hover:bg-green-700"
            data-testid="welcome-start-btn"
          >
            Start Exploring
          </Button>
          <a
            href={FACEBOOK_GROUP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full"
          >
            <Button
              variant="outline"
              className="w-full border-blue-500 text-blue-600"
              data-testid="welcome-facebook-btn"
            >
              <Users className="w-4 h-4 mr-2" />
              Join Facebook Group
            </Button>
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeModal;
